import { Account, AccountState, useUpdateAccountApi } from '@liquidbudget/common';
import { Button } from '@/components/ui/button';

type Props = {
  account: Account;
  onSuccess: () => void;
};

export function AccountRestoreForm({ account, onSuccess }: Props) {
  const { mutate, isPending } = useUpdateAccountApi({ onSuccess });

  const onSubmit = () => {
    mutate({ ...account, state: AccountState.ACTIVE });
  };

  return (
    <div className="flex justify-end gap-2 mt-6">
      <Button type="button" variant="destructive" isLoading={isPending} onClick={onSubmit}>
        Restore Account
      </Button>
    </div>
  );
}
